export const GTM_ADD_TO_CART = 'GTM_ADD_TO_CART';
export const GTM_IMPRESSIONS = 'GTM_IMPRESSIONS';
export const CART_LOAD_ERROR = 'CART_LOAD_ERROR';